import React from "react";

function CardHeader(props) {
  return <h2 className="h3 util-margin-top-0">{props.children}</h2>;
}

export default CardHeader;
